/*
 * With the release of SOH redesign we will be hitting a new endpoint: /api/v1/users/properties/list
 * All of the access logic will be determined on the server.
 */
const canAccessApplications = ({ restrictions = {} }) => {
    const hasApplicationsProperty = restrictions.hasOwnProperty('applications');
    // isAccessRestricted controls whether the application tab (in the subnav) should be  hidden or displayed
    return !hasApplicationsProperty || !restrictions.applications.isAccessRestricted;
};

const canUpdateApplications = ({ restrictions = {} }) => {
    const hasApplicationsProperty = restrictions.hasOwnProperty('applications');
    // isUpdateRestricted indicates whether the user is allowed to enable or disable applications on a listing
    return !hasApplicationsProperty || !restrictions.applications.isUpdateRestricted;
};

const canAccessLeaseBuilder = ({ restrictions = {} }) => !restrictions.isLeaseBuilderRestricted;

const canAccessConnectedExperience = ({
    currentProperty = null,
    appConfig,
}) => {
    const { config: { features: { enableConnectedExperience } } } = appConfig || {};

    // currentProperty might be null (PropertiesPage)
    const { isConnectedExperience: propertyIsConnectedExperience } = currentProperty || {};

    // check against property permissions otherwise return true
    const currentPropertyHasAccess = currentProperty ? propertyIsConnectedExperience : true;

    return enableConnectedExperience && currentPropertyHasAccess;
};

const canFeedConnectCreateListing = ({ appConfig, cookieEnabledServices }) => {
    const { config: { features: { canFeedConnectCreateListing } } } = appConfig || {};
    return canFeedConnectCreateListing || cookieEnabledServices.ZG_FEED_CONNECT_CREATE_LISTING;
};

const canFeedConnectSwitchSource = ({ appConfig, cookieEnabledServices }) => {
    const { config: { features: { canFeedConnectSwitchSource } } } = appConfig || {};
    return canFeedConnectSwitchSource || cookieEnabledServices.ZG_FEED_CONNECT_SWITCH_SOURCE;
};

const canAccessFlatFee = ({ appConfig, cookieEnabledServices }) => {
    const { config: { features: { canAccessFlatFee } } } = appConfig || {};

    return canAccessFlatFee || cookieEnabledServices.ZG_FLAT_FEE_ENABLED;
};

const canAccessListingClaiming = ({ appConfig, user }) => {
    const { config: { features: { canAccessFeedClaimAndConvert } } } = appConfig || {};
    return Boolean(canAccessFeedClaimAndConvert && user.features.canAccessFeedClaimAndConvert);
};

const canAccessRentGuarantee = ({ cookieEnabledServices }) => Boolean(cookieEnabledServices.ZG_RENT_GUARANTEE_ENABLED);

const canAccessPayments = () => true;

const canAccessGlobalAnalytics = ({ user }) => user.features.canAccessMainAnalytics;

const canAccessGlobalContacts = ({ user }) => user.features.canAccessMainContacts;

const canAccessBilling = ({ user }) => user.features.canAccessBilling;

const canAccessSettings = ({ user }) => user.features.canAccessMainSecuritySettings;

const canAccessUserManagement = ({ user }) => user.features.canAccessUserManagement;

const canAddListing = ({ user }) => (user.features.canAddListing);

const canAccessInvoicePayments = ({ user }) => user.features.canAccessInvoicePayments;

const canAccessLeases = () => true;

export default {
    canAccessApplications,
    canAccessLeaseBuilder,
    canAccessConnectedExperience,
    canFeedConnectCreateListing,
    canFeedConnectSwitchSource,
    canAccessFlatFee,
    canAccessPayments,
    canAccessGlobalAnalytics,
    canAccessGlobalContacts,
    canAccessBilling,
    canAccessSettings,
    canAccessUserManagement,
    canAddListing,
    canAccessLeases,
    canUpdateApplications,
    canAccessInvoicePayments,
    canAccessListingClaiming,
    canAccessRentGuarantee,
};
